module.exports = __webpack_public_path__ + "img/2012-12-14 20.11.19.00183bf7.jpg";